var _slicedToArray = require("/Users/dunja/Documents/code/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _classCallCheck = require("/Users/dunja/Documents/code/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/dunja/Documents/code/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/Users/dunja/Documents/code/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/dunja/Documents/code/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Users/dunja/Documents/code/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _assertThisInitialized = require("/Users/dunja/Documents/code/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var Backoff = require('backoff');
var EventEmitter = require('events');
var inherits = require('util').inherits;
var WebSocket = global.WebSocket || require('ws');
var Subprovider = require('./subprovider');
var createPayload = require('../util/create-payload');
var WebsocketSubprovider = /*#__PURE__*/function (_Subprovider) {
  "use strict";

  _inherits(WebsocketSubprovider, _Subprovider);
  function WebsocketSubprovider(_ref) {
    var _this;
    var rpcUrl = _ref.rpcUrl,
      debug = _ref.debug,
      origin = _ref.origin;
    _classCallCheck(this, WebsocketSubprovider);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(WebsocketSubprovider).call(this));

    // inherit from EventEmitter
    EventEmitter.call(_assertThisInitialized(_assertThisInitialized(_this)));
    Object.defineProperties(_assertThisInitialized(_assertThisInitialized(_this)), {
      _backoff: {
        value: Backoff.exponential({
          randomisationFactor: 0.2,
          maxDelay: 5000
        })
      },
      _connectTime: {
        value: null,
        writable: true
      },
      _log: {
        value: debug ? function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return console.info.apply(console, ['[WSProvider]'].concat(args));
        } : function () {}
      },
      _origin: {
        value: origin
      },
      _pendingRequests: {
        value: new Map()
      },
      _socket: {
        value: null,
        writable: true
      },
      _unhandledRequests: {
        value: []
      },
      _url: {
        value: rpcUrl
      }
    });
    _this._handleSocketClose = _this._handleSocketClose.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._handleSocketMessage = _this._handleSocketMessage.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._handleSocketOpen = _this._handleSocketOpen.bind(_assertThisInitialized(_assertThisInitialized(_this)));

    // Called when a backoff timeout has finished. Time to try reconnecting.
    _this._backoff.on('ready', function () {
      _this._openSocket();
    });
    _this._openSocket();
    return _this;
  }
  _createClass(WebsocketSubprovider, [{
    key: "handleRequest",
    value: function handleRequest(payload, next, end) {
      if (!this._socket || this._socket.readyState !== WebSocket.OPEN) {
        this._unhandledRequests.push(Array.from(arguments));
        this._log('Socket not open. Request queued.');
        return;
      }
      this._pendingRequests.set(payload.id, [payload, end]);
      var newPayload = createPayload(payload);
      delete newPayload.origin;
      this._socket.send(JSON.stringify(newPayload));
      this._log("Sent: ".concat(newPayload.method, " #").concat(newPayload.id));
    }
  }, {
    key: "_handleSocketClose",
    value: function _handleSocketClose(_ref2) {
      var reason = _ref2.reason,
        code = _ref2.code;
      this._log("Socket closed, code ".concat(code, " (").concat(reason || 'no reason', ")"));
      // If the socket has been open for longer than 5 seconds, reset the backoff
      if (this._connectTime && Date.now() - this._connectTime > 5000) {
        this._backoff.reset();
      }
      this._socket.removeEventListener('close', this._handleSocketClose);
      this._socket.removeEventListener('message', this._handleSocketMessage);
      this._socket.removeEventListener('open', this._handleSocketOpen);
      this._socket = null;
      this._backoff.backoff();
    }
  }, {
    key: "_handleSocketMessage",
    value: function _handleSocketMessage(message) {
      var payload;
      try {
        payload = JSON.parse(message.data);
      } catch (e) {
        this._log('Received a message that is not valid JSON:', payload);
        return;
      }

      // check if server-sent notification
      if (payload.id === undefined) {
        return this.engine.emit('data', null, payload);
      }

      // ignore if missing
      if (!this._pendingRequests.has(payload.id)) {
        return;
      }

      // retrieve payload + arguments
      var _this$_pendingRequest = this._pendingRequests.get(payload.id),
        _this$_pendingRequest2 = _slicedToArray(_this$_pendingRequest, 2),
        originalReq = _this$_pendingRequest2[0],
        end = _this$_pendingRequest2[1];
      this._pendingRequests.delete(payload.id);
      this._log("Received: ".concat(originalReq.method, " #").concat(payload.id));

      // forward response
      if (payload.error) {
        return end(new Error(payload.error.message));
      }
      end(null, payload.result);
    }
  }, {
    key: "_handleSocketOpen",
    value: function _handleSocketOpen() {
      var _this2 = this;
      this._log('Socket open.');
      this._connectTime = Date.now();

      // Any pending requests need to be resent because our session was lost
      // and will not get responses for them in our new session.
      this._pendingRequests.forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          payload = _ref4[0],
          end = _ref4[1];
        _this2._unhandledRequests.push([payload, null, end]);
      });
      this._pendingRequests.clear();
      var unhandledRequests = this._unhandledRequests.splice(0, this._unhandledRequests.length);
      unhandledRequests.forEach(function (request) {
        _this2.handleRequest.apply(_this2, request);
      });
    }
  }, {
    key: "_openSocket",
    value: function _openSocket() {
      this._log('Opening socket...');
      this._socket = new WebSocket(this._url, [], this._origin ? {
        headers: {
          origin: this._origin
        }
      } : {});
      this._socket.addEventListener('close', this._handleSocketClose);
      this._socket.addEventListener('message', this._handleSocketMessage);
      this._socket.addEventListener('open', this._handleSocketOpen);
    }
  }]);
  return WebsocketSubprovider;
}(Subprovider); // multiple inheritance
Object.assign(WebsocketSubprovider.prototype, EventEmitter.prototype);
module.exports = WebsocketSubprovider;